import axios from 'axios';

const authApi = axios.create({
  baseURL: `${process.env.VUE_APP_API_AUTH_URL}`,
});

export default authApi;
